module.exports = __webpack_public_path__ + "8d8b88fac27cefc28ce6ba6a2e02ca15.svg";


//////////////////
// WEBPACK FOOTER
// ./spa/images/icons/applepay.svg
// module id = 1505
// module chunks = 1 5 7 8 15 80